// extracted by mini-css-extract-plugin
var _1 = "Quad__background--ou9qL";
var _2 = "Quad__border--gfIrD";
var _3 = "Quad__main--QlCTb";
var _4 = "Quad__mainDisabled--xZ3bF";
var _5 = "Quad__sh3--vyFbW";
var _6 = "Quad__sh4--nqQdD";
var _7 = "Quad__sh5--yysZZ";
export { _1 as "background", _2 as "border", _3 as "main", _4 as "mainDisabled", _5 as "sh3", _6 as "sh4", _7 as "sh5" }
